






import { Component, Mixins } from "vue-property-decorator";
import AutoTrade from "trade/components/auto_trade/Index.vue";
import mixins from "@/mixins";

@Component({
  components: {
    AutoTrade
  }
})
class AutoTradePage extends Mixins(mixins.page) {
  get title() {
    return this.$t("trade.auto") as string;
  }

  mounted() {
    this.$store.dispatch("trade/loadData");
  }
}
export default AutoTradePage;
